<div mat-dialog-content>Form Saved Successfully.</div>
<div mat-dialog-actions style="text-align: center;padding: 1em;">
    <button mat-raised-button id="button" (click)="close()">Ok</button>
</div>